<template>
   <div style="margin-top: 200px; margin-left: 400px;">
   	    <v-row class="desposite-dashboadpage investomerter-dashboad-page">
		      <v-col xs="8" md="8">
		        <div class="head-text investomerter-heading">
		            <h1>Make a Payment</h1>
		        </div>
		      </v-col>
		      <v-col xs="4" md="4" class="investomerter_select-userbox"></v-col>
	    </v-row>
        <v-row class="desposite-dashboadpage investomerter-dashboad-page">
	        <v-col cols="7">
               <a href="javascript:void(0)" v-on:click="redirectToPaymentWindow()" style="font-size: 20px;">Click here to make a payment</a>
	        </v-col>
	        <v-col cols="7">
			    <v-col cols="7">
	               <span><b style="font-weight: 15px;">Please don't close the window we are feteching your data form bank!</b></span>
		        </v-col>
	        </v-col>	
	    </v-row>	
   </div>
</template>   
<script>
import axios from "axios";

export default {
	data: () => ({
	    link:"",
	    logo_image:process.env.VUE_APP_ROOT_ICONS_URL + "Logo.png",
	    id:"",
	    awsCognitoId:"",
	    userMobile:"",
	    user_name:"",
	    userEmail:"",
	    check_payment_info:true,
		intervalID:""
	}),
	created(){
		if(this.check_payment_info == true){
			if(this.check_payment_info == true){
                this.intervalID = setInterval(() =>
				this.checkPaymentInfo() 
				, 3000);
			}
			else{
                clearInterval(this.intervalID)
			}   
		}
	},

	methods: {
	  	redirectToPaymentWindow(){
	  		this.id      = this.$route.params.id
	  		let formdata = new FormData();
            formdata.append("id", this.id);
            axios.post(process.env.VUE_APP_ROOT_API + "get-customer-info", formdata)
            .then((response) => {
            	if(response.data.status =="success"){
                    this.link         = response.data.link
                    this.awsCognitoId = response.data.awsCognitoId
                    this.userMobile   = response.data.userMobile
                    this.user_name    = response.data.user_name
                    this.userEmail    = response.data.userEmail
                    window.open(this.link, "", "width=600,height=500,left=200,top=100");			
            	}
            	else{
            		Toast.fire({
		                icon: "error",
		                title: response.data.message,
		                confirmButtonText: `Ok`,
		            });
            	}
            })
            .catch(() => {
              
            });
        },

        checkPaymentInfo(){
        	if(this.awsCognitoId !=""){
            	let formdata = new FormData();
            	formdata.append("awsCognitoId", this.awsCognitoId);
            	formdata.append("userMobile", this.userMobile);
            	formdata.append("user_name", this.user_name);
            	formdata.append("userEmail", this.userEmail);
	            axios.post(process.env.VUE_APP_ROOT_API + "check-payment-info", formdata)
	            .then((response) => {
	            	if(response.data.payment_status =='PAID'){
	            		if(this.check_payment_info ==true){
	            			swal.fire({
				                icon:"success",
				                text:"Payment made successfully. Now you can continue with mobile or web application",
				                showCancelButton: false,
				                confirmButtonColor: '#051d42',
				                confirmButtonText: 'OK',
				            })
				            .then((result) => {
                                this.$router.push({ name: 'Login' }).catch(()=>{});
					        });
	            		}
	            		this.check_payment_info = false
	            	}
	            	else{}
	            })
	            .catch(() => {
	                
	            });
            }
        }
    },
};
</script>
